import request from '@/utils/request'

// 获取讲义库的资源
export const GetHanout = (data) => request.get('/resources/handout/', { params: data })

// 获取作业库的资源
export const GetWork = (data) => request.get('/resources/homework/', { params: data })

// 获取考试库的资源
export const GetKaoShi = (data) => request.get('/resources/exam/', { params: data })

// 获取习题库的资源
export const GetXiti = (data) => request.get('/resources/exercises/', { params: data })

// 获取素材库的资源
export const GetSucai = (data) => request.get('/resources/vegetable/', { params: data })

// 发请求获取所有老师
export const GetAllTeacher = (data) => request.get('/users/teachers/', { params: data })

// 获取讲义详情
export const GetHanoutDetail = (id) => request.get(`/resources/handout/${id}/`)

// 获取讲义素材 根据id列表
export const GetHanoutList = (data) => request.post('/resources/get_vegetable/', data)

// 获取讲义试题列表 根据id列表
export const GetHanoutTestList = (data) => request.post('/resources/get_exercises/', data)

// 获取素材详情
export const GetSource = (id) => request.get(`/resources/vegetable/${id}/`)

// 获取试题详情
export const GetTestQuestionDetail = (id) => request.get(`/resources/exercises/${id}/`)

// 获取作业详情
export const GetJobDetail = (id) => request.get(`/resources/homework/${id}/`)

// 获取考试详情
export const GetExamDetail = (id) => request.get(`/resources/exam/${id}/`)
